// import React from "react";
// import { FaCheckCircle } from "react-icons/fa";

// function ConfirmOrder() {
//   return (
//     <div className="container py-5 mt-5">
//       <div className="row justify-content-center">
//         <div className="col-lg-8">

//           {/* SUCCESS CARD */}
//           <div
//             style={{
//               background: "#fff",
//               borderRadius: "12px",
//               padding: "30px",
//               boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
//               textAlign: "center",
//             }}
//           >
//             {/* ICON */}
//             <FaCheckCircle
//               size={70}
//               style={{ color: "#28a745", marginBottom: "15px" }}
//             />

//             {/* TITLE */}
//             <h2 className="fw-bold mb-2">Order Confirmed</h2>
//             <p className="text-muted mb-4">
//               Your order has been successfully placed 🎉
//             </p>

//             {/* ORDER SUMMARY */}
//             <div
//               style={{
//                 background: "#f8f9fa",
//                 borderRadius: "10px",
//                 padding: "20px",
//                 textAlign: "left",
//                 marginBottom: "20px",
//               }}
//             >
//               <h5 className="fw-semibold mb-3">Order Summary</h5>

//               <div className="d-flex justify-content-between mb-2">
//                 <span>Order ID</span>
//                 <strong>#ORD123456</strong>
//               </div>

//               <div className="d-flex justify-content-between mb-2">
//                 <span>Date</span>
//                 <span>{new Date().toLocaleDateString()}</span>
//               </div>

//               <div className="d-flex justify-content-between mb-2">
//                 <span>Payment Method</span>
//                 <span>UPI</span>
//               </div>

//               <hr />

//               <div className="d-flex justify-content-between fw-bold">
//                 <span>Total</span>
//                 <span className="text-success">₹ 18053</span>
//               </div>
//             </div>

//             {/* USER DETAILS */}
//             <div
//               style={{
//                 background: "#f8f9fa",
//                 borderRadius: "10px",
//                 padding: "20px",
//                 textAlign: "left",
//                 marginBottom: "25px",
//               }}
//             >
//               <h5 className="fw-semibold mb-3">Billing Details</h5>

//               <p className="mb-1"><strong>Name:</strong> John Doe</p>
//               <p className="mb-1"><strong>Email:</strong> john@email.com</p>
//               <p className="mb-1"><strong>Phone:</strong> 9876543210</p>
//               <p className="mb-0">
//                 <strong>Address:</strong> Mohan Nagar, Ghaziabad, Uttar Pradesh
//               </p>
//             </div>

//             {/* BUTTONS */}
//             <div className="d-flex gap-2 flex-wrap justify-content-center">
//               <button className="btn btn-primary px-4">
//                 Continue Shopping
//               </button>

//               <button className="btn btn-outline-secondary px-4">
//                 View Orders
//               </button>
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ConfirmOrder;


// import React from "react";
// import { FaCheckCircle, FaBox, FaTruck } from "react-icons/fa";
// import Lottie from "lottie-react";
// import successAnimation from "../assets/success confetti.json";

// function ConfirmOrder() {
//   return (
//     <div style={styles.page}>
//       <div className="container">

//         {/* TOP CARD */}
//         <div style={styles.topCard}>

//             {/* LOTTIE ANIMATION */}
//             <div style={{ width: 180, margin: "0 auto" }}>
//                 <Lottie
//                 animationData={successAnimation}
//                 loop={false}
//                 />
//             </div>

//             <h1 style={styles.heading}>
//                 Order Confirmed 🎉
//             </h1>

//             <p style={styles.subText}>
//                 Your order has been placed successfully. We’ll notify you with updates.
//             </p>

//             {/* ORDER STATUS */}
//             <div style={styles.statusWrapper}>
//                 <Status icon={<FaCheckCircle />} label="Confirmed" active />
//                 <Line />
//                 <Status icon={<FaTruck />} label="Shipped" />
//                 <Line />
//                 <Status icon={<FaBox />} label="Delivered" />
//             </div>

//             <button style={styles.primaryBtn}>Track Order</button>
//             </div>

//         {/* ORDER DETAILS */}
//         <div style={styles.card}>
//           <h3 style={styles.cardTitle}>Order Details</h3>

//           <p style={{ marginBottom: "20px" }}>
//             Confirmation No: <span style={styles.highlight}>#6200600</span>
//           </p>

//           {/* PRODUCT */}
//           <div style={styles.productCard}>
//             <img
//               src="https://via.placeholder.com/90"
//               alt=""
//               style={styles.productImg}
//             />

//             <div style={{ flex: 1 }}>
//               <p style={styles.productTitle}>Course Purchase</p>
//               <small style={{ color: "#777" }}>Qty: 1</small>
//             </div>

//             <strong style={{ fontSize: "18px" }}>₹18,053</strong>
//           </div>

//           {/* ADDRESS + PAYMENT */}
//           <div className="row mt-4">
//             <div className="col-md-6">
//               <h6 style={styles.sectionTitle}>Billing Address</h6>
//               <p className="mb-0">John Doe</p>
//               <p className="mb-0">Mohan Nagar</p>
//               <p className="mb-0">Ghaziabad, UP</p>
//             </div>

//             <div className="col-md-6">
//               <h6 style={styles.sectionTitle}>Payment Summary</h6>
//               <p style={{ marginBottom: "10px" }}>UPI</p>

//               <Row label="Subtotal" value="₹18,053" />
//               <Row label="Tax" value="₹0" />

//               <hr />

//               <Row label="Total" value="₹18,053" bold />
//             </div>
//           </div>
//         </div>

//         {/* SUPPORT */}
//         <div className="row g-3">
//           {["Chat", "Call", "Email", "WhatsApp"].map((item, i) => (
//             <div className="col-md-3 col-6" key={i}>
//               <div style={styles.supportCard}>
//                 <strong>{item}</strong>
//                 <p>Support</p>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* CTA */}
//         <div style={styles.cta}>
//           <h3>Continue Shopping 🛍️</h3>
//           <p>Discover more products and offers.</p>
//           <button style={styles.primaryBtn}>Shop Now</button>
//         </div>

//       </div>
//     </div>
//   );
// }

// /* 🔹 SMALL COMPONENTS */
// const Status = ({ icon, label, active }) => (
//   <div style={{ textAlign: "center", opacity: active ? 1 : 0.4 }}>
//     <div style={{
//       background: active ? "#ffe5e2" : "#eee",
//       padding: "12px",
//       borderRadius: "50%",
//       display: "inline-block"
//     }}>
//       {React.cloneElement(icon, { size: 22, color: active ? "#ff5a4f" : "#999" })}
//     </div>
//     <p style={{ marginTop: "8px", fontSize: "14px" }}>{label}</p>
//   </div>
// );

// const Line = () => (
//   <div style={{
//     width: "60px",
//     height: "2px",
//     background: "#ddd"
//   }} />
// );

// const Row = ({ label, value, bold }) => (
//   <div style={{
//     display: "flex",
//     justifyContent: "space-between",
//     fontWeight: bold ? "600" : "400",
//     marginBottom: "5px"
//   }}>
//     <span>{label}</span>
//     <span>{value}</span>
//   </div>
// );

// /* 🔹 STYLES */
// const styles = {
//   page: {
//     background: "#f9f6f2",
//     minHeight: "100vh",
//     padding: "40px 0"
//   },

//   topCard: {
//     background: "#fff",
//     borderRadius: "20px",
//     padding: "40px 20px",
//     textAlign: "center",
//     marginBottom: "30px",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
//     animation: "fadeIn 0.8s ease"
//  },

//   heading: {
//     fontWeight: "700",
//     marginTop: "15px"
//   },

//   subText: {
//     color: "#777",
//     marginBottom: "25px"
//   },

//   statusWrapper: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "20px",
//     marginBottom: "25px",
//     flexWrap: "wrap"
//   },

//   card: {
//     background: "#fff",
//     borderRadius: "15px",
//     padding: "25px",
//     marginBottom: "30px",
//     boxShadow: "0 8px 25px rgba(0,0,0,0.05)"
//   },

//   cardTitle: {
//     fontWeight: "700",
//     marginBottom: "10px"
//   },

//   highlight: {
//     color: "#ff5a4f",
//     fontWeight: "600"
//   },

//   productCard: {
//     display: "flex",
//     alignItems: "center",
//     gap: "15px",
//     padding: "15px",
//     borderRadius: "12px",
//     background: "#fafafa"
//   },

//   productImg: {
//     borderRadius: "10px"
//   },

//   productTitle: {
//     fontWeight: "600",
//     marginBottom: "5px"
//   },

//   sectionTitle: {
//     fontWeight: "600",
//     marginBottom: "10px"
//   },

//   supportCard: {
//     background: "#fff",
//     padding: "15px",
//     borderRadius: "12px",
//     textAlign: "center",
//     boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
//     cursor: "pointer",
//     transition: "0.3s",
//   },

//   cta: {
//     background: "#fff",
//     borderRadius: "20px",
//     padding: "30px",
//     textAlign: "center",
//     marginTop: "30px",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
//   },

//   primaryBtn: {
//     background: "#ff5a4f",
//     color: "#fff",
//     borderRadius: "30px",
//     padding: "12px 28px",
//     border: "none",
//     fontWeight: "600",
//     cursor: "pointer",
//     marginTop: "10px",
//     transition: "0.3s"
//  }
// };

// export default ConfirmOrder;


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle, FaBox, FaTruck } from "react-icons/fa";
import Lottie from "lottie-react";
import successAnimation from "../assets/success confetti.json";
import failedAnimation from "../assets/failed.json";
import pendingAnimation from "../assets/pending.json";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../config/config";

function ConfirmOrder() {
  const navigate = useNavigate();
  const { order_id } = useParams();
  const orderId = order_id || Math.floor(100000 + Math.random() * 900000);

  const [orderData, setOrderData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    // Send orderId to backend on page load
    const sendOrderId = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}/getPurchaseDetails`, // replace with your backend URL
          { order_id: orderId }, // body goes here
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response);
        setOrderData(response.data);
      } catch (err) {
        console.error(err);
        setError("Failed to confirm order. Please try again.");
      }
    };

    sendOrderId();
  }, [orderId]);

  const status = orderData?.purchase_History?.transaction_status?.toUpperCase() || "PENDING";


  const statusConfig = {
    SUCCESS: {
      title: "Order Confirmed 🎉",
      message: "Your order has been placed successfully.",
      animation: successAnimation,
    },
    FAILED: {
      title: "Payment Failed ❌",
      message: "Your payment could not be processed.",
      animation: failedAnimation,
    },
    PENDING: {
      title: "Payment Pending ⏳",
      message: "Your payment is under processing.",
      animation: pendingAnimation,
    },
  };

  const currentStatus = statusConfig[status] || statusConfig.PENDING;

  if (error) {
    return (
      <div style={styles.loaderWrapper}>
        <p style={{ color: "red" }}>{error}</p>
      </div>
    );
  }


  const courseImage = orderData?.purchase_History.products[0].image
      ? `${IMAGE_URL}/uploads/${encodeURIComponent(orderData?.purchase_History.products[0].image)}`
      : "/placeholder-course.png";

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px);}
          to { opacity: 1; transform: translateY(0);}
        }
        .btn-hover:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(255,90,79,0.3);
        }
        .support-card:hover { transform: translateY(-6px); }
        .product-hover:hover { transform: scale(1.02); }
      `}</style>

      <div className="container">

        {/* TOP CARD */}
        <div style={styles.topCard}>
          <div style={{ width: 180, margin: "0 auto" }}>
              <Lottie animationData={currentStatus.animation} loop={false} />
            </div>

            <h1 style={styles.heading}>{currentStatus.title}</h1>

            <p style={styles.subText}>
              {currentStatus.message}
            </p>

          {/* <div style={styles.statusWrapper}>
            <Status icon={<FaCheckCircle />} label="Confirmed" active />
            <Line />
            <Status icon={<FaTruck />} label="Shipped" />
            <Line />
            <Status icon={<FaBox />} label="Delivered" />
          </div> */}

          {/* <button style={styles.primaryBtn} className="btn-hover">
            Track Order
          </button> */}
        </div>

        {/* ORDER DETAILS */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>Order Details</h3>
          <p style={{ marginBottom: "20px" }}>
            Confirmation No: <span style={styles.highlight}>#{orderId}</span>
          </p>

          <div style={styles.productCard} className="product-hover">
            <img
              src={courseImage}
              alt={courseImage}
              style={styles.productImg}
            />
            <div style={{ flex: 1 }}>
              <p style={styles.productTitle}>Course Purchase: {orderData?.purchase_History.products[0].product_name}</p>
              <small style={{ color: "#777" }}>Qty: {orderData?.purchase_History.products.length}</small>
            </div>
            <strong style={{ fontSize: "18px" }}>₹ {orderData?.purchase_History.products[0].price[0].price}</strong>
          </div>

          <div className="row mt-4">
            <div className="col-md-6">
              <h6 style={styles.sectionTitle}>Billing Address</h6>
              <p className="mb-0">{orderData?.purchase_History.billing_details.city}</p>
              <p className="mb-0">{orderData?.purchase_History.billing_details.Address}, {orderData?.purchase_History.billing_details.country}</p>
            </div>
            <div className="col-md-6">
              <h6 style={styles.sectionTitle}>Payment Summary</h6>
              <p style={{ marginBottom: "10px" }}>UPI</p>
              <Row label="Subtotal" value={`₹ ${orderData?.purchase_History.products[0].price[0].price * orderData?.purchase_History.products.length}`} />
              <Row label="Tax" value="₹ 0" />
              <hr />
              <Row label="Total" value={`₹ ${orderData?.purchase_History.products[0].price[0].price * orderData?.purchase_History.products.length}`} bold />
            </div>
          </div>
        </div>

        {/* SUPPORT */}
        {/* <div className="row g-3">
          {["Chat", "Call", "Email", "WhatsApp"].map((item, i) => (
            <div className="col-md-3 col-6" key={i}>
              <div style={styles.supportCard} className="support-card">
                <strong>{item}</strong>
                <p>Support</p>
              </div>
            </div>
          ))}
        </div> */}

        {/* CTA */}
        <div style={styles.cta}>
          <h3>Continue Shopping 🛍️</h3>
          <p>Discover more products and offers.</p>
          <button style={styles.ctaBtn} className="btn-hover" onClick={() => navigate("/")}>
            Shop Now
          </button>
        </div>

      </div>
    </div>
  );
}

/* 🔹 COMPONENTS */

const Status = ({ icon, label, active }) => (
  <div style={{ textAlign: "center", opacity: active ? 1 : 0.4 }}>
    <div
      style={{
        background: active ? "#ffe5e2" : "#eee",
        padding: "14px",
        borderRadius: "50%",
        display: "inline-block"
      }}
    >
      {React.cloneElement(icon, {
        size: 22,
        color: active ? "#ff5a4f" : "#999"
      })}
    </div>
    <p style={{ marginTop: "8px", fontSize: "14px" }}>{label}</p>
  </div>
);

const Line = () => (
  <div
    style={{
      width: "60px",
      height: "3px",
      background: "#ddd",
      borderRadius: "10px"
    }}
  />
);

const Row = ({ label, value, bold }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      fontWeight: bold ? "600" : "400",
      marginBottom: "6px"
    }}
  >
    <span>{label}</span>
    <span>{value}</span>
  </div>
);

/* 🔹 STYLES */

const styles = {
  page: {
    background: "linear-gradient(135deg, #fff1ef, #f9f6f2)",
    minHeight: "100vh",
    padding: "50px 0",
    fontFamily: "Poppins, sans-serif"
  },

  topCard: {
    background: "rgba(255,255,255,0.9)",
    backdropFilter: "blur(12px)",
    borderRadius: "25px",
    padding: "50px 20px",
    textAlign: "center",
    marginBottom: "30px",
    boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
    animation: "fadeIn 0.6s ease"
  },

  heading: {
    fontWeight: "700",
    fontSize: "32px"
  },

  subText: {
    color: "#666",
    marginBottom: "30px"
  },

  statusWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "25px",
    marginBottom: "30px",
    flexWrap: "wrap"
  },

  card: {
    background: "#fff",
    borderRadius: "20px",
    padding: "30px",
    marginBottom: "30px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
    animation: "fadeIn 0.8s ease"
  },

  cardTitle: {
    fontWeight: "700",
    marginBottom: "15px",
    fontSize: "20px"
  },

  highlight: {
    color: "#ff5a4f",
    fontWeight: "600"
  },

  productCard: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    padding: "18px",
    borderRadius: "15px",
    background: "#fafafa",
    transition: "0.3s"
  },

  productImg: {
    borderRadius: "12px",
    width: "90px",
    height: "90px",
    objectFit: "cover"
  },

  productTitle: {
    fontWeight: "600"
  },

  sectionTitle: {
    fontWeight: "600",
    marginBottom: "10px"
  },

  supportCard: {
    background: "#fff",
    padding: "20px",
    borderRadius: "15px",
    textAlign: "center",
    boxShadow: "0 5px 15px rgba(0,0,0,0.06)",
    cursor: "pointer",
    transition: "all 0.3s ease"
  },

  cta: {
    background: "linear-gradient(135deg, #ff5a4f, #ff7a6f)",
    borderRadius: "25px",
    padding: "40px",
    textAlign: "center",
    marginTop: "30px",
    color: "#fff",
    boxShadow: "0 15px 40px rgba(255,90,79,0.3)"
  },

  primaryBtn: {
    background: "#ff5a4f",
    color: "#fff",
    borderRadius: "30px",
    padding: "14px 30px",
    border: "none",
    fontWeight: "600",
    cursor: "pointer",
    transition: "0.3s"
  },

  ctaBtn: {
    background: "#fff",
    color: "#ff5a4f",
    borderRadius: "30px",
    padding: "14px 30px",
    border: "none",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "10px"
  }
};

export default ConfirmOrder;